import { render, staticRenderFns } from "./delivery-history-add-or-update.vue?vue&type=template&id=40f51535"
import script from "./delivery-history-add-or-update.vue?vue&type=script&lang=js"
export * from "./delivery-history-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports